import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSecurity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M11.005 1.764a1.882 1.882 0 0 1 1.989 0 10.07 10.07 0 0 0 5.813 1.516c.986-.045 1.943.708 1.943 1.8v8.738c0 1.33-.523 2.554-1.26 3.613-.736 1.06-1.713 1.993-2.694 2.763a18.872 18.872 0 0 1-2.824 1.828c-.413.216-.79.39-1.1.51-.156.061-.303.112-.436.149-.119.032-.277.069-.436.069-.16 0-.318-.037-.437-.07a4.628 4.628 0 0 1-.435-.148 11.342 11.342 0 0 1-1.1-.51 18.871 18.871 0 0 1-2.824-1.828c-.982-.77-1.958-1.703-2.695-2.763-.736-1.059-1.26-2.283-1.26-3.613V5.08c0-1.091.957-1.844 1.943-1.8a10.07 10.07 0 0 0 5.813-1.516ZM12.2 3.037a.382.382 0 0 0-.4 0 11.57 11.57 0 0 1-6.676 1.741.393.393 0 0 0-.276.096.27.27 0 0 0-.098.205v8.74c0 .928.366 1.857.99 2.756.625.898 1.482 1.727 2.39 2.438.904.71 1.837 1.284 2.592 1.68.378.197.703.345.951.442a3.123 3.123 0 0 0 .327.11l.036-.01c.07-.02.166-.052.29-.1a9.84 9.84 0 0 0 .951-.443c.756-.395 1.689-.97 2.593-1.679.908-.71 1.764-1.54 2.389-2.438.625-.899.99-1.828.99-2.757V5.08a.27.27 0 0 0-.097-.205.393.393 0 0 0-.277-.096A11.57 11.57 0 0 1 12.2 3.037Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M15.509 9.449a.75.75 0 0 1 .042 1.06l-3.692 4a.75.75 0 0 1-1.102 0l-2.308-2.5A.75.75 0 1 1 9.55 10.99l1.757 1.903 3.14-3.403a.75.75 0 0 1 1.06-.042Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorSecurity;
